module.exports = __webpack_public_path__ + "img/commend1.b74a48b4.png";